import { fetch } from '@atlassian/eoc-fetch';
import type { ResponderType } from '@atlassian/eoc-responder-names';

import { type AutoCompleteEndpoint, type AutoCompleteResponse } from '../../common/types';

export const AUTO_COMPLETE_ENDPOINTS_LIMIT = '50';

export const createAutoCompleteEndpoint = (types?: ResponderType[]) => {
	return (({ keyword }, signalParam, limit = AUTO_COMPLETE_ENDPOINTS_LIMIT) => {
		const params = new URLSearchParams({
			...(types && { types: types.join(',') }),
			...(keyword && { keyword }),
			limit,
		});
		return fetch<AutoCompleteResponse>(
			`/v1/alerts/responders/auto-complete?${params.toString()}`,
			signalParam,
		);
	}) as AutoCompleteEndpoint;
};

export const getSchedules = createAutoCompleteEndpoint(['schedule']);
export const getEscalations = createAutoCompleteEndpoint(['escalation']);
export const getUsers = createAutoCompleteEndpoint(['user']);
export const getTeams = createAutoCompleteEndpoint(['team']);
export const getResponders = createAutoCompleteEndpoint();
